import React, { useEffect, useRef, useState } from "react";

import "./news.scss";
import { observer } from "mobx-react-lite";

import NewsCard from "./news_card/news_card";
import cupStore from "../../../stores/cup_store/cup_store";
import { useNavigate } from "react-router-dom";

function CupNews() {
	const carouselRef = useRef<HTMLDivElement>(null);
	const carouselCardRef = useRef<HTMLDivElement>(null);

	const [currentCard, changeCurrentCard] = useState<number>(0);

	const navigate = useNavigate();

	const scrollToCard = (card: number) => {
		if (!carouselRef || !carouselRef.current) return;
		if (!carouselCardRef || !carouselCardRef.current) return;
		if (!isMobile) {
			const cardWidth = (carouselRef.current.offsetWidth / 100) * 19.3;
			carouselRef.current.scrollLeft =
				card *
				((carouselCardRef.current.offsetWidth / cardWidth) *
					(cardWidth + 16 * 2));
		} else {
			const cardWidth = (carouselRef.current.offsetWidth / 100) * 85;
			carouselRef.current.scrollLeft =
				card *
				((carouselCardRef.current.offsetWidth / cardWidth) *
					(cardWidth + 10 * 2));
		}
		// Добавляем к ширине margin блока. Должно совпадать со значениями в css
		changeCurrentCard(card);
	};

	const [width, setWidth] = useState<number>(window.innerWidth);
	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	const isMobile = width <= 630;

	const countOfCards = () => cupStore.newsCards?.length;

	const [scrollStartX, changeScrollStartX] = useState<number>();
	const [scrollTimeout, changeScrollTimeout] = useState<NodeJS.Timeout>();
	const scrollHandler = (event: any) => {
		if (!event || !event.targetTouches?.length) return;
		if (scrollTimeout) clearTimeout(scrollTimeout);
		if (!scrollStartX) changeScrollStartX(event.targetTouches[0].clientX);
		changeScrollTimeout(
			setTimeout(() => {
				if (!event || !event.targetTouches?.length || !scrollStartX)
					return;
				const scrollEndX = +event.targetTouches[0].clientX;
				if (
					scrollStartX - scrollEndX > 30 &&
					currentCard + (!isMobile ? 5 : 1) !== countOfCards()
				)
					scrollToCard(currentCard + 1);
				if (scrollStartX - scrollEndX < -30 && currentCard !== 0)
					scrollToCard(currentCard - 1);
				changeScrollStartX(0);
			}, 100)
		);
	};

	return (
		<div className="news">
			<div className="news_header">Новости</div>
			<div className="carousel_wrapper">
				<div
					className="prev button"
					onClick={() => {
						if (currentCard === 0) return;
						scrollToCard(currentCard - 1);
					}}
				>
					<i className="arrow left"></i>
				</div>
				<div
					className="next button"
					onClick={() => {
debugger
						const count = countOfCards();
						if (!count) return;
						//if (currentCard + 5 === count) return;
						if (count <= 4) return;
						scrollToCard(currentCard + 1);
					}}
				>
					<i className="arrow right"></i>
				</div>
				<div
					className="news_carousel"
					ref={carouselRef}
					onTouchMove={scrollHandler}
				>
					{cupStore.newsCards &&
						cupStore.newsCards.map((card, index) => (
							<div
								className={
									"news_card_wrapper " +
									(index < currentCard ||
									index + 1 >
										currentCard + (!isMobile ? 5 : 1)
										? "smoke "
										: "")
								}
								key={index}
								ref={carouselCardRef}
								onClick={() => navigate(`/news?id=${card.id}`)}
							>
								<NewsCard card={card}></NewsCard>
							</div>
						))}
				</div>
			</div>
		</div>
	);
}

export default observer(CupNews);
